import { UploadOutlined } from "@ant-design/icons";
import { Alert, Button, DatePicker, Form, message } from "antd";
import Dragger from "antd/lib/upload/Dragger";
import { useState } from "react";
import { useLoaderData, useNavigate, useRouteLoaderData } from "react-router";
import axiosInstance from "../common/api";
import { requiredField } from "../common/common";
import FormPage from "../common/FormPage";

export default function UploadCertificate() {
  const course = useLoaderData();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onFinish = async (values) => {
    const formData = new FormData();
    formData.append("file", values.file[0].originFileObj);
    formData.append("certificateDate", values.certificateDate.format("YYYY-MM-DD"));
    setLoading(true);
    setError(null);
    try {
      await axiosInstance.post(`course/${course.id}/certificate`, formData);
      message.success("Attestato caricato con successo");
      navigate(`/courses/${course.id}`);
    } catch (error) {
      setError(
        error.response?.status === 409
          ? "Il corso ha già un attestato."
          : "Caricamento non riuscito. Riprova.",
      );
    } finally {
      setLoading(false);
    }
  };

  if (course.certificateDate != null) {
    return (
      <Alert
        type="info"
        showIcon
        title="Il corso ha già un attestato."
        action={<Button onClick={() => navigate(`/courses/${course.id}`)}>Torna al corso</Button>}
      />
    );
  }

  return (
    <FormPage title="Carica attestato" onFinish={onFinish}>
      {error && <Alert type="error" showIcon title={error} style={{ marginBottom: 16 }} />}
      <Form.Item name="certificateDate" label="Data attestato" rules={[requiredField]}>
        <DatePicker
          format="DD/MM/YYYY"
          style={{ width: "100%" }}
          disabledDate={(date) => date && date.isAfter(new Date(), "day")}
        />
      </Form.Item>
      <Form.Item
        name="file"
        label="File"
        valuePropName="fileList"
        getValueFromEvent={(event) => event?.fileList}
        rules={[requiredField]}
      >
        <Dragger accept="application/pdf" maxCount={1} beforeUpload={() => false}>
          <p>Trascina qui il file (Solo .pdf accettati)</p>
          <Button icon={<UploadOutlined />}>Seleziona file</Button>
        </Dragger>
      </Form.Item>
      <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
        <Button htmlType="submit" type="primary" loading={loading}>
          Carica
        </Button>
      </Form.Item>
    </FormPage>
  );
}
